import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  buttons: {
    paddingTop: theme.spacing(3.75),
    paddingRight: theme.spacing(2.5),
  },
  actionButton: {
    marginBottom: theme.spacing(1.25),
  },
}));
